<ion-item class="item-detail-card" [ngClass]="{'opted-in': itemData?.isOptedIn}" lines="none" (click)="handleCardClick($event)">
  <ion-grid class="item-detail-grid">
    <!-- First Row: Title on left, buttons on right -->
    <ion-row class="item-detail-row-first">
      <ion-col size="auto" class="item-title-col">
        <ion-label class="item-title">{{ itemData?.itemName }}</ion-label>
      </ion-col>
      <ion-col size="auto" class="item-buttons-col">
        <!-- Status Toggle Button -->
        <ion-toggle
          #toggle
          [checked]="itemData?.isOptedIn"
          [disabled]="isToggleDisabled"
          (ionChange)="handleStatusToggleClick($event)"
          class="status-toggle">
        </ion-toggle>
        
        <!-- Arrow Icon -->
        <ion-icon
          *ngIf="itemData?.hasSignature"
          name="chevron-forward-outline"
          class="arrow-icon"
          [ngClass]="{'opted-in': itemData?.isOptedIn}"
          (click)="handleSignatureClick($event)">
        </ion-icon>
      </ion-col>
    </ion-row>

    <!-- Second Row: Opted In and Opted In Source -->
    <ion-row class="item-detail-row-second">
      <ion-col size="6">
        <div class="item-info-column">
          <div class="info-label">{{ 'OPTED_IN_DATE' | translate }}</div>
          <div class="info-value">{{ itemData?.optedInDate || '--' }}</div>
        </div>
      </ion-col>
      <ion-col size="6">
        <div class="item-info-column">
          <div class="info-label">{{ 'OPTED_IN_SOURCE' | translate }}</div>
          <div class="info-value">{{ itemData?.optedInSource || '--' }}</div>
        </div>
      </ion-col>
    </ion-row>

    <!-- Third Row: Opted Out and Opted Out Source -->
    <ion-row class="item-detail-row-third">
      <ion-col size="6">
        <div class="item-info-column">
          <div class="info-label">{{ 'OPTED_OUT_DATE' | translate }}</div>
          <div class="info-value">{{ itemData?.optedOutDate || '--' }}</div>
        </div>
      </ion-col>
      <ion-col size="6">
        <div class="item-info-column">
          <div class="info-label">{{ 'OPTED_OUT_SOURCE' | translate }}</div>
          <div class="info-value">{{ itemData?.optedOutSource || '--' }}</div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-item>

